// extracted by mini-css-extract-plugin
export var container = "_sd-0";
export var inputWidth = "_sd-1";